
import { useEnvStore } from '@remote/store/env'
import { defineComponent } from 'vue'
import { mapState, mapGetters, useStore } from 'vuex'
import MoreInfoItem from '@remote/components/MoreInfoItem.vue'
import { USER_PROTOCOL_URL, PRIVACY_PROTOCOL_URL, PAN_PROTOCOL_URL, VIP_PROTOCOL_URL } from '@remote/constant'
import router from '@remote/router'

export default defineComponent({
  components: { MoreInfoItem },
  setup: () => {
    document.title = '关于'
    const envStore = useEnvStore()
    const store = useStore()
    return { store, envStore }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['deviceInfoWatchData']),
    ...mapGetters(['isFullScreen']),
  },
  methods: {
    getFullYear () {
      const date = new Date()
      return date.getFullYear() //获取完整的年份(4位)
    },
    handleBack () {
      this.$router.go(-1)
    },
    goProtocol (title) {
      let URL = ''
      switch (title) {
        case '迅雷产品服务使用协议':
          URL = USER_PROTOCOL_URL
          break
        case '迅雷隐私权政策':
          URL = PRIVACY_PROTOCOL_URL
          break
        case '迅雷云盘服务协议':
          URL = PAN_PROTOCOL_URL
          break
        case '迅雷会员服务协议':
          URL = VIP_PROTOCOL_URL
          break
      }
      this.store.commit('update', { currentIframeUrl: URL, currentIframeTitle: title, currentIframeShowClose: false })
      router.push({
        name: 'pluginIframe',
        query: router.currentRoute.value.query,
      })
    },
  },
})
